import { createSlice } from '@reduxjs/toolkit'
import { getCookie } from 'apps-common'

interface LoadingState {
  blockingOperations: number
}

const initialState: LoadingState = {
  blockingOperations: 0,
}

function traceLog(message: string) {
  const loadingSliceDebug = getCookie('loadingSliceDebug') === 'true'

  if (loadingSliceDebug) {
    console.trace(message)
  }
}

export const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    addBlockingOperation(state) {
      state.blockingOperations++

      traceLog(`addBlockingOperation -> ${state.blockingOperations}`)
    },
    removeBlockingOperation(state) {
      if (state.blockingOperations > 0) {
        state.blockingOperations--
      }

      traceLog(`removeBlockingOperation -> ${state.blockingOperations}`)
    },
    resetBlockingOperations(state) {
      state.blockingOperations = 0

      traceLog(`resetBlockingOperations -> ${state.blockingOperations}`)
    },
  },
})

export const { addBlockingOperation, removeBlockingOperation, resetBlockingOperations } = loadingSlice.actions

export default loadingSlice.reducer
